import { render } from "./ElectionRatingView.vue?vue&type=template&id=c84c49ce&scoped=true"
import script from "./ElectionRatingView.vue?vue&type=script&lang=js"
export * from "./ElectionRatingView.vue?vue&type=script&lang=js"

import "./ElectionRatingView.vue?vue&type=style&index=0&id=c84c49ce&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84c49ce"]])

export default __exports__